import http from '../http/http';

import { generateEndpoint, UPDATE_LICENCE_RECORD } from '../http/endpoints';

export default (() => {
    const update = (licenceType) =>
        http.post(generateEndpoint(UPDATE_LICENCE_RECORD, { licenceType }));

    return {
        update,
    };
})();
